import { type ReactNode, useState } from 'react'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { ConfirmLinkForm } from './ConfirmLinkForm'

interface ConfirmLinkDialogProps {
  orgId: string
  /** The button that opens it. */
  children: ReactNode
}

/** Staff hand a customer in onboarding the link to review, confirm and send their own application. */
export function ConfirmLinkDialog({ orgId, children }: ConfirmLinkDialogProps) {
  const [open, setOpen] = useState(false)

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Send the confirm link</DialogTitle>
          <DialogDescription>
            They check the application, fill in what&apos;s missing and confirm it, which asks the carriers
            for quotes. The link signs them in for 7 days.
          </DialogDescription>
        </DialogHeader>
        {/* Mounted only while open, so every opening starts from the customer as they are now. */}
        {open && <ConfirmLinkForm orgId={orgId} onSent={() => setOpen(false)} />}
      </DialogContent>
    </Dialog>
  )
}
